<div class="row">
	<div class="col-sm-6">
		<h2 class="semi-bold in-block">
			<i class="fas fa-ticket-alt mgn-right10"></i>
			Tickets |
			<em class="regular">{{ viewStateService.includeClosed ? 'All' : 'Open only' }}</em>
		</h2>
	</div>
	<div class="col-sm-2 col-sm-offset-4">
		<button (click)="onIncludeClosedClick()" class="{{ viewStateService.includeClosed ? 'limeGreen-bg white-text' : 'gray-bg' }}">Include closed</button>
	</div>
</div>

<div class="row mgn-top15">
	<table *ngIf="tickets?.length > 0" class="w-full text-left rtl:text-right text-gray-500">
		<thead class="semi-bold sticky top-0 z-10 text-xs bg-gray-100 text-black">
			<tr>
				<th (click)="onSortClick({ column: 'TicketTypeName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Type
					<i [class]="getSortIconClass('TicketTypeName')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'AssignedToUserName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Assigned To
					<i [class]="getSortIconClass('AssignedToUserName')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'TicketStateName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Status
					<i [class]="getSortIconClass('TicketStateName')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'ReminderTime', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Reminder Time
					<i [class]="getSortIconClass('ReminderTime')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'LastTicketActionDate', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Last Action
					<i [class]="getSortIconClass('LastTicketActionDate')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'IsHighPriority', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					High Priority
					<i [class]="getSortIconClass('IsHighPriority')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'Title', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Summary
					<i [class]="getSortIconClass('Title')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'LocationCount', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Locations
					<i [class]="getSortIconClass('LocationCount')" class="ml-1"></i>
				</th>
				<th (click)="onSortClick({ column: 'CreatedDate', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
					Created
					<i [class]="getSortIconClass('CreatedDate')" class="ml-1"></i>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				*ngFor="
					let ticket of tickets
						| paginate
							: {
									itemsPerPage: 25,
									currentPage: viewStateService.pageNumber,
									totalItems: viewStateService.mainTableTotalItems
							  }
				"
				class="border-b text-[12px] xl:text-sm text-black cursor-pointer hover:opacity-90"
				[ngClass]="ticket.rowBgColor"
				(click)="onRowSelect(ticket)"
			>
				<td class="py-2 px-2">
					<p class="flex items-center">
						{{ ticket.TicketTypeName }}
					</p>
				</td>

				<td class="py-2 px-2">
					<p class="flex items-center">
						{{ ticket.AssignedToUserName }}
					</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.TicketStateName }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ (ticket.ReminderTime | date : 'M/d/yyyy') ?? 'N/A' }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.lastActionDateView }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.IsHighPriority }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.Title }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.LocationCount }}</p>
				</td>
				<td class="py-2 px-2">
					<p class="flex items-center">{{ ticket.CreatedDate | date : 'M/d/yyyy' }}</p>
				</td>
			</tr>
		</tbody>
	</table>
	<div *ngIf="tickets?.length === 0" class="text-center text-gray-500">
		<p>No tickets for this client.</p>
	</div>

	<div *ngIf="tickets?.length > 0" class="flex justify-between items-center mx-4 mt-2 mb-[100px]">
		<div>
			<pagination-controls (pageChange)="onPageClick($event)" class="pagination"></pagination-controls>
			<input class="h-10 !w-16 mr-4" [(ngModel)]="viewStateService.pageNumber" (input)="onPageClick()" />
		</div>
		<div *ngIf="viewStateService.mainTableTotalItems">
			<span class="semi-bold">Total Items:</span>
			{{ viewStateService.mainTableTotalItems }}
		</div>
	</div>
</div>
